import { getAgentTypeDisplayName } from '../resolve-agent-command.js';
import type { AcpManagerContext } from './acp-manager-context.js';
import type { LogPromptReceivedFromBridgeOptions } from './types.js';

export function logPromptReceivedFromBridge(
  ctx: AcpManagerContext,
  opts: LogPromptReceivedFromBridgeOptions,
): void {
  const { agentType, mode } = opts;
  const preferredForPrompt = (agentType ?? ctx.backendFallbackAgentType) ?? null;
  const modeLabel = typeof mode === 'string' && mode.trim() !== '' ? mode.trim() : 'not set';
  ctx.log(
    `[Agent] Prompt received (${getAgentTypeDisplayName(preferredForPrompt)}, mode: ${modeLabel})`,
  );
}
